import cls from "@fvilers/cls";
import {
  ChangeEventHandler,
  ComponentPropsWithoutRef,
  RefAttributes,
} from "react";
import { useFieldContext } from "../../hooks/useAppForm";
import styles from "./Checkbox.module.css";

export type CheckboxProps = {
  checked?: boolean;
  onChecked?: (checked: boolean) => void;
  type?: "checkbox" | "radio";
} & Omit<ComponentPropsWithoutRef<"input">, "children" | "type"> &
  RefAttributes<HTMLDivElement>;

export function Checkbox({
  className,
  onChecked,
  ref,
  type = "checkbox",
  ...props
}: CheckboxProps) {
  const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    if (props.readOnly) {
      e.preventDefault();
      return;
    }
    if (onChecked && e.currentTarget instanceof HTMLInputElement) {
      onChecked(e.currentTarget.checked);
    }
  };

  return (
    <div
      className={cls(
        styles.Checkbox,
        type === "radio" && styles.radio,
        props.disabled && styles.disabled,
        className,
      )}
      data-disabled={props.disabled || undefined}
      data-read-only={props.readOnly || undefined}
      data-slot="control"
      ref={ref}
    >
      <input
        data-autofocus={props.autoFocus || undefined}
        onChange={handleChange}
        type="checkbox"
        value={props.value ?? "on"}
        {...props}
      />
      <span className={styles.CheckboxIndicator} data-slot="indicator" />
    </div>
  );
}

export function CheckboxField(props: CheckboxProps) {
  const field = useFieldContext<boolean>();
  return (
    <Checkbox
      {...props}
      checked={field.state.value}
      form={field.form.formId}
      onBlur={field.handleBlur}
      onChecked={field.handleChange}
    />
  );
}
